export default __webpack_public_path__ + "static/media/page404.18951477.png";